import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";

const AddEntity = (props) => {
  const { isModalOpen, handleModalClose } = props;
  const { createEntity, selectedEntityType, selectedJurisdiction } =
    props.GainLossListsScreenStore;
  const { CommonStore } = props;
  const [entityName, setEntityName] = useState("");
  const [activeStatus, setActiveStatus] = useState({
    label: "Active",
    value: true,
  });
  const [errorMessage, setErrorMessage] = useState("");

  const isDataValid = () => {
    if (entityName && activeStatus) {
      return true;
    }
    return false;
  };

  const handleAddEntity = () => {
    if (!isDataValid()) {
      setErrorMessage("Please enter valid values");
      return;
    }
    createEntity(
      {
        entityName: entityName,
        isActive: activeStatus?.value,
        entityType: selectedEntityType?.value,
        jurisdiction: selectedJurisdiction?.value,
      },
      CommonStore
    );
    handleClose();
  };

  const handleClose = () => {
    setEntityName("");
    setActiveStatus({
      label: "Active",
      value: true,
    });
    setErrorMessage("");
    handleModalClose();
  };
  return (
    <div className="add-entity-dialog">
      <Modal show={isModalOpen} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>List Value</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage && <div className="error-message">{errorMessage}</div>}
          <Form>
            <Form.Group className="mb-3" controlId="entity-name">
              <Form.Label>List value name</Form.Label>
              <Form.Control
                type="input"
                value={entityName}
                onChange={(event) => setEntityName(event.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="acitve-status">
              <Form.Label>Active/Inactive</Form.Label>
              <Select
                className="active-status-dropdown"
                options={[
                  { label: "Active", value: true },
                  { label: "Inactive", value: false },
                ]}
                value={activeStatus}
                onChange={(value) => setActiveStatus(value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleAddEntity}>
            Add
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddEntity;
